import {
  RECEIVE_FIELDS,
  RECEIVE_FIELDS_FAILURE,
  RECEIVE_FIELDS_MULTI_OPERATIONS,
  RECEIVE_FIELDS_FAILURE_MULTI_OPERATIONS,
  REQUEST_FIELD_SEARCH_INDEX,
  RECEIVE_FIELD_SEARCH_INDEX,
  FIELD_SEARCH_INDEX_FAILURE,
  SEARCH_FIELDS_BY_NAME,
  RECEIVE_FIELD_NAME_SEARCH_RESULTS,
  CLEAR_FIELD_NAME_SEARCH,
} from '../constants/actionTypes';
import type { FieldSearchIndex } from '../requesters/uapiFieldsRequester/uapiFieldsRequester';

export interface ReceiveFieldsAction {
  type: typeof RECEIVE_FIELDS;
  payload: unknown;
}

export interface FieldsFailureAction {
  type: typeof RECEIVE_FIELDS_FAILURE;
}

export interface ReceiveFieldsMultiOperationsAction {
  type: typeof RECEIVE_FIELDS_MULTI_OPERATIONS;
  payload: unknown;
}

export interface FieldsFailureMultiOperationsAction {
  type: typeof RECEIVE_FIELDS_FAILURE_MULTI_OPERATIONS;
}

export interface RequestFieldSearchIndexAction {
  type: typeof REQUEST_FIELD_SEARCH_INDEX;
  operationIds: string[];
}

export interface ReceiveFieldSearchIndexAction {
  type: typeof RECEIVE_FIELD_SEARCH_INDEX;
  searchIndex: FieldSearchIndex;
}

export interface FieldSearchIndexFailureAction {
  type: typeof FIELD_SEARCH_INDEX_FAILURE;
}

export interface SearchFieldsByNameAction {
  type: typeof SEARCH_FIELDS_BY_NAME;
  searchTerm: string;
}

export interface ReceiveFieldNameSearchResultsAction {
  type: typeof RECEIVE_FIELD_NAME_SEARCH_RESULTS;
  searchIndex: FieldSearchIndex;
  searchTerm: string;
}

export interface ClearFieldNameSearchAction {
  type: typeof CLEAR_FIELD_NAME_SEARCH;
}

export type FieldsActions =
  | ReceiveFieldsAction
  | FieldsFailureAction
  | ReceiveFieldsMultiOperationsAction
  | FieldsFailureMultiOperationsAction
  | RequestFieldSearchIndexAction
  | ReceiveFieldSearchIndexAction
  | FieldSearchIndexFailureAction
  | SearchFieldsByNameAction
  | ReceiveFieldNameSearchResultsAction
  | ClearFieldNameSearchAction;

export function receiveFields(payload: unknown): ReceiveFieldsAction {
  return {
    type: RECEIVE_FIELDS,
    payload,
  };
}

export function fieldsFailure(): FieldsFailureAction {
  return {
    type: RECEIVE_FIELDS_FAILURE,
  };
}

export function receiveFieldsMultiOperations(payload: unknown): ReceiveFieldsMultiOperationsAction {
  return {
    type: RECEIVE_FIELDS_MULTI_OPERATIONS,
    payload,
  };
}

export function fieldsFailureMultiOperations(): FieldsFailureMultiOperationsAction {
  return {
    type: RECEIVE_FIELDS_FAILURE_MULTI_OPERATIONS,
  };
}

export const requestFieldSearchIndex = (operationIds: string[]): RequestFieldSearchIndexAction => ({
  type: REQUEST_FIELD_SEARCH_INDEX,
  operationIds,
});

export const receiveFieldSearchIndex = (searchIndex: FieldSearchIndex): ReceiveFieldSearchIndexAction => ({
  type: RECEIVE_FIELD_SEARCH_INDEX,
  searchIndex,
});

export const fieldSearchIndexFailure = (): FieldSearchIndexFailureAction => ({
  type: FIELD_SEARCH_INDEX_FAILURE,
});

export const searchFieldsByName = (searchTerm: string): SearchFieldsByNameAction => ({
  type: SEARCH_FIELDS_BY_NAME,
  searchTerm,
});

export const receiveFieldNameSearchResults = (
  searchIndex: FieldSearchIndex,
  searchTerm: string
): ReceiveFieldNameSearchResultsAction => ({
  type: RECEIVE_FIELD_NAME_SEARCH_RESULTS,
  searchIndex,
  searchTerm,
});

export const clearFieldNameSearch = (): ClearFieldNameSearchAction => ({
  type: CLEAR_FIELD_NAME_SEARCH,
});
